<template>
    <div class="a-infoBar a-infoBar--warning text-sm" v-text="text" />
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>